import { SignIn } from "@clerk/clerk-react";

export default function Login() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-brand-50 to-white flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="flex flex-col items-center mb-8">
          <img
            src="/images/media-dingo-logo.svg"
            alt="Media Dingo"
            className="h-32 w-auto object-contain mb-3"
          />
          <p className="text-gray-500 text-sm">Just get it done.</p>
        </div>

        <SignIn
          routing="hash"
          signUpUrl="/login#/sign-up"
          appearance={{
            elements: {
              card: "card shadow-none border border-gray-200",
              headerTitle: "text-xl font-semibold text-gray-900",
              headerSubtitle: "text-sm text-gray-500",
              formButtonPrimary: "btn-primary w-full py-2.5 text-sm",
              footerActionLink:
                "text-brand-600 hover:text-brand-700 font-medium",
              socialButtonsBlockButton:
                "flex items-center justify-center gap-3 w-full px-4 py-2.5 border border-gray-300 rounded-lg bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors",
            },
          }}
        />

        <p className="text-center text-xs text-gray-400 mt-6">
          Free plan: 5 posts/month. No credit card required.
        </p>
      </div>
    </div>
  );
}
